import './multilingual-quill-editor.scss'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { BaseComponent } from '../../common/base-component'
import { Component } from 'vue-property-decorator'
import { LanguageDefinition } from '../../common/languageDefinition'
import { quillEditor } from 'vue-quill-editor'

@Component({
  template: require('./multilingual-quill-editor.pug'),
  components: {
    quillEditor
  },
  props: {
    translations: { type: Array },
    prop: { type: String },
    disabled: { type: Boolean },
    maxlength: { type: Number },
    editorOption: {
      type: Object,
      default: () => ({
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ direction: 'rtl' }],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
            ['clean']
          ]
        }
      })
    }
  }
})
export class MultilingualQuillEditorComponent extends BaseComponent {
  someBigNumberForSortingLast = 999
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  translations: Array<any>
  prop: string
  availableLanguages: Map<string, LanguageDefinition>
  toggleCollapse = false
  unwatch: () => void
  maxlength: number

  async created(): Promise<void> {
    this.availableLanguages = LanguageDefinition.GetAllDefinedLanguages()

    if (this.translations) {
      this.consolideTranslations()
    }

    this.registerWatcher()
  }

  registerWatcher(): void {
    this.unwatch = this.$watch('translations', function(newValue, oldValue): void {
      this.consolideTranslations()
    })
  }

  unRegisterWatcher(): void {
    if (this.unwatch) this.unwatch()
  }

  consolideTranslations(): void {
    if (this.translations == undefined) return

    this.unRegisterWatcher()

    this.availableLanguages.forEach((languageDefinition: LanguageDefinition, languageCountryCode: string) => {
      const existingTranslation = this.translations.find(t => t.languageCountryCode === languageCountryCode)
      if (existingTranslation == null) {
        this.translations.push({
          languageCountryCode: languageCountryCode,
          displayOrder: languageDefinition.displayOrder
        })
      } else {
        existingTranslation.displayOrder = languageDefinition.displayOrder
      }
    })

    if (this.translations) {
      this.translations.sort(
        (s1, s2) =>
          (s1.displayOrder ? s1.displayOrder : this.someBigNumberForSortingLast) -
          (s2.displayOrder ? s2.displayOrder : this.someBigNumberForSortingLast)
      )
    }
  }

  onEditorChange({ quill, html }: { quill: any; html: string }, translation: any): void {
    if (this.maxlength && quill.getLength() - 1 > this.maxlength) {
      quill.deleteText(this.maxlength, quill.getLength())
    }
    translation[this.prop] = quill.root.innerHTML
  }

  assumeEmptyValuesAsUndefined(translation, prop): void {
    if (translation[prop] === '') delete translation[prop]
  }

  getLanguageIconPath(languageCountryCode: string): string {
    if (!this.availableLanguages) return ''

    const languageDefinition = this.availableLanguages.get(languageCountryCode)
    return languageDefinition ? languageDefinition.languageIconPath : ''
  }
}
